import {
  Component,
  computed, ElementRef,
  input,
  model,
  OnDestroy,
  OnInit, QueryList,
  signal,
  TemplateRef,
  ViewChild, ViewChildren,
} from '@angular/core';
import { FormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import _ from 'lodash';
import { debounceTime, distinctUntilChanged, Subject, takeUntil } from 'rxjs';
import { DynamicFormComponent } from 'src/app/core/dynamic-form/dynamic-form.component';
import {
  DynamicFormOptions,
  FieldConfig,
  FieldTypeEnum,
} from 'src/app/core/dynamic-form/dynamicForm.interface';
import { ToastService } from 'src/app/core/toast/toast.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { environment } from 'src/environments/environment';
import { ClientiService } from '../../clienti/clienti.service';
import {
  MissionDto,
  UpdateMission,
  CreateMission,
  TimeUnlockConfig,
  GpsUnlockConfig,
  UnlockType,
  UNLOCK_TYPE_ICONS,
  UNLOCK_TYPE_LABEL,
} from '../missioni-dto';
import { EditHistoryData } from 'src/app/core/edit-history/edit-history';
import { GestioneMissioniService } from '../gestione-missioni.service';
import { DynamicFormModule } from 'src/app/core/dynamic-form/dynamic-form.module';
import { EditHistoryModule } from 'src/app/core/edit-history/edit-history.module';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { slideDownUp } from 'src/app/core/global-app-animations';
import * as L from 'leaflet';
import { LeafletModule } from '@bluehalo/ngx-leaflet';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { HttpClient } from '@angular/common/http';
import { QRCodeComponent } from 'angularx-qrcode';
import { GestioneStepComponent } from '../../gestione-step/gestione-step.component';
import {
  IconBolt,
  IconHourglassHigh,
  IconPin,
  IconQrcode,
} from 'angular-tabler-icons/icons';
import { provideTablerIcons, TablerIconComponent } from 'angular-tabler-icons';
import { selectionButtonClass } from '../../gestione-partite/partite-dto';
import { DDDropDownBase } from 'src/app/model/response/auth-r';
import { GenericDD } from 'src/app/model/generic-data';
import { customBreadCrumbRequest } from 'src/app/core/bread-crumbs/bread-crumbs.component';

@Component({
  selector: 'app-form-missioni',
  imports: [
    CommonModule,
    DynamicFormModule,
    EditHistoryModule,
    MatButtonModule,
    FormsModule,
    LeafletModule,
    NgxMaskDirective,
    QRCodeComponent,
    GestioneStepComponent,
    TablerIconComponent,
  ],
  providers: [
    provideNgxMask(),
    provideTablerIcons({
      IconBolt,
      IconHourglassHigh,
      IconQrcode,
      IconPin,
    }),
  ],
  templateUrl: './form-missioni.component.html',
  styleUrl: './form-missioni.component.scss',
  animations: [slideDownUp],
})
export class FormMissioniComponent implements OnInit, OnDestroy {
  @ViewChild('myForm') myForm!: DynamicFormComponent;
  @ViewChild('unlockType') unlockType!: TemplateRef<any>;
  @ViewChildren("qrComp", { read: ElementRef }) qrComps!: QueryList<ElementRef>;
  //leaflet map
  private map!: L.Map;

  latitude: number = 45.4641943; // Default to Milano
  longitude: number = 9.1896346;
  latitudineInput: string = '45.4641943';
  longitudineInput: string = '9.1896346';
  range: number = 1000; // Default 5km range

  currentAddress: string = '';
  isSearching: boolean = false;
  private addressSearchSubject = new Subject<string>();

  // Map options
  options: L.MapOptions = {
    layers: [
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 18,
        attribution: '© OpenStreetMap contributors',
      }),
    ],
    zoom: 13,
    center: L.latLng(this.latitude, this.longitude),
  };

  // Layers array for ngx-leaflet
  layers: L.Layer[] = [];

  // Layer references
  private marker!: L.Marker;
  private rangeCircle!: L.Circle;

  idGame = input<string>('');
  internalGameId = signal<string>('');

  selectedUnlockType: UnlockType = UnlockType.immediate;

  unlockTypes = Object.values(UnlockType) as UnlockType[];
  unlockTypeIcons = UNLOCK_TYPE_ICONS;
  unlockTypeLabels = UNLOCK_TYPE_LABEL;

  unlockTime = model<number>(0);

  formattedTime = computed(() => {
    let totalSeconds = this.unlockTime();
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    let result = '';
    if (hours > 0) result += `${hours} ore `;
    if (minutes > 0 || hours > 0) result += `${minutes} minuti `;
    result += `${seconds} secondi`;

    return result.trim();
  });

  //DATA FROM API, THE ONE THAT GETS CHANGED AND THE OG ONE
  //CHANGE THE TYPE TO THE ONE YOU NEED
  public object?: MissionDto;

  //configurations
  timeConfig: TimeUnlockConfig = { seconds: 0 };
  gpsConfig: GpsUnlockConfig = {
    latitudine: this.latitude,
    longitudine: this.longitude,
    gpsRadius: this.range,
  };

  //ID
  codice: string = '';

  buttonClass: string = selectionButtonClass;

  //FORM OPTIONS, DEFINED IN CONSTRUCTOR
  form2Opts: DynamicFormOptions;

  //FOR SHOWING OR HIDING FORM, USEFULL FOR REINITIALIZING
  ready: boolean = false;

  //FOR SHOWING CREATEDBY AND EDITEDBY
  editHistoryData: EditHistoryData | undefined;

  //FORM FIELDS
  regConfig2: FieldConfig[] = [];

  // missioni list from gioco
  currentMissioni: MissionDto[] = [];
  currentDataForDD: GenericDD[] = [];

  //NO MEMORY LEAKS FIX
  private theEnd$ = new Subject<void>();

  //for qr code

  loadingQrCode: boolean = false;


  constructor(
    private route: ActivatedRoute, //IF YOU USE paramMap
    private router: Router,
    private toast: ToastService,
    private missionService: GestioneMissioniService,
    private clientiService: ClientiService,
    private localStorageService: LocalStorageService,
    private http: HttpClient
  ) {
    this.form2Opts = {
      buttonAtBottom: true, //PUT THIS ALWAYS TO MAKE BUTTON STICK TO BOTTOM
      formType: 'add', //add, edit, view
    };
  }

  ngOnDestroy(): void {
    this.theEnd$.next();
    this.theEnd$.complete();
  }

  ngOnInit(): void {
    if (this.idGame()) {
      this.internalGameId.set(this.idGame());
    } else {
      this.internalGameId.set(this.route.snapshot.paramMap.get('id') || '');
    }

    this.form2Opts = {
      buttonAtBottom: true, //PUT THIS ALWAYS TO MAKE BUTTON STICK TO BOTTOM
      formType: 'add', //add, edit, view
      editOptions: {
        entityName: 'mission', //for lockserver apis
        entityDisplayName: 'Missione', //placeholder for messages
        deleteUrl: `${environment.apiUrl}/missions`, //delete url
        deleteMessage: `Stai per eliminare la missione, procedere?`, //message on delete dialog
        deleteItem: '', //delete code/id depends, assign this when initializing form
        entityId: '', //id for lockserver apis
        isFem: false, //is fem or male?
        redirectUrl: `home/partita/${this.idGame()}`, //url where it goes after delete
      },
      addOptions: {
        entityName: 'mission',
        entityDisplayName: 'Missione',
        isFem: false,
        redirectUrl: `home/partita/${this.idGame()}`, //url where it goes when cancelling
      },
    };

    this.initializeForm();
  }

  getMissionGame() {
    this.missionService
      .getMissionByAdventure(this.internalGameId())
      .pipe(takeUntil(this.theEnd$))
      .subscribe({
        next: (data: MissionDto[]) => {
          this.currentMissioni = data;

          this.currentDataForDD = [];
          this.currentDataForDD.push({
            codice: 'Nessuna dipendenza',
            id: null,
          });
          for (let data of this.currentMissioni) {
            let dataToPuh: GenericDD = {
              codice: data.name,
              id: data.id,
            };
            this.currentDataForDD.push(dataToPuh);
          }

          let i = this.regConfig2.findIndex((x) => x.name == 'missionParent');
          if (i > -1 && this.myForm != undefined) {
            this.regConfig2[i].data = this.currentDataForDD;
            this.regConfig2[i].value = this.object?.dependsOn;
            this.myForm.parsedFields[i] = _.cloneDeep(this.regConfig2[i]);
          }
        },
      });
  }

  goBackToGame() {
    this.router.navigate(['home/partite', this.internalGameId()]);
  }

  //based on route decides what form to show, adapt this logic if url contains more add or edit strings
  initializeForm() {
    if (this.router.url.includes('new')) {
      this.form2Opts.formType = 'add';
      this.localStorageService.setTitolo('Nuova missione');
      this.initializeFormFields();
    } else {
      this.form2Opts.formType = 'edit';
      this.initializeEditForm();
    }
  }

  initializeFormFields() {
    this.regConfig2 = [
      {
        type: FieldTypeEnum.input,
        name: 'name',
        label: 'Nome',
        isRequired: true,
        width: 'w-full',
        value: this.object ? this.object.name : undefined,
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message: 'Inserisci un nome',
          },
        ],
      },
      {
        type: FieldTypeEnum.textarea,
        name: 'shortDescription',
        label: 'Breve descrizione',
        isRequired: true,
        width: 'w-full',
        value: this.object ? this.object.shortDescription : undefined,
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message: 'Inserisci una breve descrizione',
          },
        ],
      },
      {
        type: FieldTypeEnum.textarea,
        name: 'description',
        label: 'Descrizione',
        isRequired: true,
        width: 'w-full',
        value: this.object ? this.object.description : undefined,
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message: 'Inserisci una descrizione',
          },
        ],
      },
      {
        type: FieldTypeEnum.select,
        name: 'missionParent',
        label: 'Missione collegata',
        isRequired: false,
        width: 'w-full',
        value: this.object ? this.object.dependsOn : undefined,
        data: this.currentDataForDD,
      },
      {
        type: FieldTypeEnum.numberInput,
        name: 'punti',
        label: 'Punti',
        isRequired: true,
        width: 'w-full',
        value:
          this.object &&
          this.object.pointsRedeem &&
          this.object.pointsRedeem > 0
            ? this.object.pointsRedeem
            : 0,
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message: 'Inserisci un valore',
          },
        ],
      },

      {
        type: FieldTypeEnum.numberInput,
        name: 'hearts',
        label: 'Cuori',
        isRequired: true,
        width: 'w-full',
        value: this.object ? this.object.hearts : 4,
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message: 'Inserisci il numero di cuori',
          },
          {
            name: 'min',
            validator: Validators.min(1),
            message: 'È richiesto almeno un cuore',
          },
        ],
      },

      {
        type: FieldTypeEnum.checkbox,
        name: 'formValid',
        value: this.form2Opts.formType == 'edit',
        hidden: true,
        validations: [
          {
            name: 'true',
            validator: Validators.requiredTrue,
            message: '',
          },
        ],
      },

      {
        type: FieldTypeEnum.embed,
        name: 'unlockType',
        width: 'w-full',
      },
    ];

    this.ready = true;

    setTimeout(() => {
      if (this.selectedUnlockType == UnlockType.gps) {
        this.mapInit();
      }

      this.validateData();
    }, 100);

    this.getMissionGame();
  }

  //make api call and get data for edit
  initializeEditForm() {
    this.codice = this.route.snapshot.paramMap.get('id') || '';

    this.missionService
      .read(this.codice)
      .pipe(takeUntil(this.theEnd$))
      .subscribe({
        next: (response: MissionDto) => {
          this.object = _.cloneDeep(response);
          this.internalGameId.set(response.adventureFk);
          console.warn(this.object);

          if (this.object.unlockType == UnlockType.time) {
            const timeCfg = JSON.parse(
              this.object.configurationJson
            ) as TimeUnlockConfig;
            console.log(timeCfg.seconds);
            this.unlockTime.set(timeCfg.seconds);
            // usa timeCfg.duratin
          } else if (this.object.unlockType == UnlockType.gps) {
            const gpsCfg = JSON.parse(
              this.object.configurationJson
            ) as GpsUnlockConfig & { gpsLatitude?: number; gpsLongitude?: number };
            this.latitude = gpsCfg.latitudine ?? gpsCfg.gpsLatitude ?? this.latitude;
            this.longitude = gpsCfg.longitudine ?? gpsCfg.gpsLongitude ?? this.longitude;
            this.syncCoordinateInputs();
            this.range = gpsCfg.gpsRadius;
          }

          this.selectedUnlockType = this.object.unlockType;

          this.localStorageService.setTitolo(
            `Modifica missione ${response.name}`
          );

          let req: customBreadCrumbRequest = {
            oldString: response.id,
            newString: response.name,
          }
          this.localStorageService.setCustomBreadCrumb(req);

          if (this.form2Opts.editOptions) {
            this.form2Opts.editOptions.deleteItem = '' + this.object.id;
            this.form2Opts.editOptions.entityId = this.object.id;
          }

          //run this method to display form
          this.initializeFormFields();
        },
        error: () => {},
      });
  }

  changeUnlockType(newVal: UnlockType) {
    this.selectedUnlockType = newVal;
    if (newVal == UnlockType.gps) this.mapInit();
  }

  //fires when submitting
  submit(event: any) {
    if (this.form2Opts.formType == 'add') {
      this.add(event);
    } else {
      this.edit(event);
    }
  }

  //edit submit
  edit(event: any) {
    console.log(event);
    let data: UpdateMission = {
      name: event.name,
      description: event.description,
      shortDescription: event.shortDescription,
      adventureFk: this.internalGameId(),
      isSecondary: false,
      unlockType: this.selectedUnlockType,
      pointsRedeem: event.punti,
      configurationJson: {},
      hearts: event.hearts,
      dependsOn: event.missionParent,
    };

    if (this.selectedUnlockType == UnlockType.gps) {
      let gps: GpsUnlockConfig = {
        latitudine: this.latitude,
        longitudine: this.longitude,
        gpsRadius: this.range,
      };
      data.configurationJson = gps;
    } else if (this.selectedUnlockType == UnlockType.time) {
      let time: TimeUnlockConfig = {
        seconds: this.unlockTime(),
      };
      data.configurationJson = time;
    }

    this.missionService
      .update(this.codice, data)
      .pipe(takeUntil(this.theEnd$))
      .subscribe({
        next: (response: MissionDto) => {
          this.toast.success('Modifiche salvate');

          this.initializeForm();
        },
        error: () => {},
      });
  }

  //add submit
  add(event: any) {
    console.log(event);
    let data: CreateMission = {
      name: event.name,
      description: event.description,
      shortDescription: event.shortDescription,
      adventureFk: this.internalGameId(),
      isSecondary: false,
      unlockType: this.selectedUnlockType,
      pointsRedeem: event.punti,
      configurationJson: {},
      hearts: event.hearts,
      dependsOn: event.missionParent,
    };

    if (this.selectedUnlockType == UnlockType.gps) {
      let gps: GpsUnlockConfig = {
        latitudine: this.latitude,
        longitudine: this.longitude,
        gpsRadius: this.range,
      };
      data.configurationJson = gps;
    } else if (this.selectedUnlockType == UnlockType.time) {
      let time: TimeUnlockConfig = {
        seconds: this.unlockTime(),
      };
      data.configurationJson = time;
    }

    this.missionService
      .create(data)
      .pipe(takeUntil(this.theEnd$))
      .subscribe({
        next: (response: MissionDto) => {
          this.toast.success('Missione creata');
          this.router.navigate(['home/missioni', response.id]);
        },
        error: () => {},
      });
  }

  onFormChanges(event: any) {
    this.validateData();
  }

  validateData() {
    switch (this.selectedUnlockType) {
      case 'immediate':
        this.myForm.form.controls['formValid'].setValue(true);
        break;
      case 'time':
        this.myForm.form.controls['formValid'].setValue(this.unlockTime() > 0);
        break;
      case 'gps':
        this.myForm.form.controls['formValid'].setValue(
          this.latitude != undefined &&
            this.longitude != undefined &&
            this.range > 0
        );
        break;
      case 'qr':
        this.myForm.form.controls['formValid'].setValue(true);
        break;
    }
  }

  //LEAFLET METHODS

  mapInit(): void {
    // Set initial center based on input coordinates
    this.options.center = L.latLng(this.latitude, this.longitude);

    // Initialize layers
    this.initializeLayers();

    // Get initial address
    this.reverseGeocode(this.latitude, this.longitude);

    // Setup address search debouncing
    this.addressSearchSubject
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe(() => {
        this.searchAddress();
      });
  }

  // Geocoding methods
  private async reverseGeocode(lat: number, lng: number): Promise<void> {
    try {
      const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&zoom=18&addressdetails=1`;
      const response = await this.http.get<any>(url).toPromise();

      if (response && response.display_name) {
        this.currentAddress = response.display_name;
      }
    } catch (error) {
      console.error('Reverse geocoding failed:', error);
      this.currentAddress = `${lat.toFixed(5)}, ${lng.toFixed(5)}`;
    }
  }

  public async searchAddress(): Promise<void> {
    if (!this.currentAddress.trim()) return;

    this.isSearching = true;

    try {
      const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
        this.currentAddress
      )}&limit=1&addressdetails=1`;
      const response = await this.http.get<any[]>(url).toPromise();

      if (response && response.length > 0) {
        const result = response[0];
        const lat = parseFloat(result.lat);
        const lng = parseFloat(result.lon);

        // Update location
        this.updateLocation(lat, lng);

        // Update address to the canonical form
        this.currentAddress = result.display_name;
      } else {
        alert('Address not found. Please try a different search term.');
      }
    } catch (error) {
      console.error('Geocoding failed:', error);
      alert('Failed to search address. Please try again.');
    } finally {
      this.isSearching = false;
    }
  }

  onAddressChange(): void {
    // Debounced address search
    this.addressSearchSubject.next(this.currentAddress);
  }

  onMapReady(map: L.Map): void {
    this.map = map;

    // Fit map to show the range circle
    setTimeout(() => {
      this.fitMapToRange();
    }, 100);
  }

  onMapClick(event: L.LeafletMouseEvent): void {
    const { lat, lng } = event.latlng;

    console.log(lat, lng);
    // Update internal coordinates
    this.latitude = lat;
    this.longitude = lng;
    this.syncCoordinateInputs();

    // Move marker and circle to clicked position
    this.marker.setLatLng([lat, lng]);
    this.rangeCircle.setLatLng([lat, lng]);

    // Update popup content
    this.marker.setPopupContent(
      `Location<br>Lat: ${lat.toFixed(5)}<br>Lng: ${lng.toFixed(5)}<br>Range: ${
        this.range
      } km`
    );

    // Optionally open the popup to show new coordinates
    this.marker.openPopup();

    // Update address via reverse geocoding
    this.reverseGeocode(lat, lng);

    // Fit map to show the range circle at new location
    this.fitMapToRange();
  }

  private initializeLayers(): void {
    // Create marker
    this.marker = L.marker([this.latitude, this.longitude], {
      icon: this.createCustomIcon(),
    }).bindPopup(
      `Location<br>Lat: ${this.latitude.toFixed(
        5
      )}<br>Lng: ${this.longitude.toFixed(5)}<br>Range: ${this.range} km`
    );

    // Create range circle
    this.rangeCircle = L.circle([this.latitude, this.longitude], {
      color: '#2196F3',
      fillColor: '#2196F3',
      fillOpacity: 0.2,
      weight: 2,
      radius: this.range, // Convert km to meters
    });

    // Add to layers array
    this.layers = [this.marker, this.rangeCircle];
  }

  private createCustomIcon(): L.Icon {
    return L.icon({
      iconUrl: 'assets/marker-icon.png',
      iconRetinaUrl: 'assets/marker-icon-2x.png',
      shadowUrl: 'assets/marker-shadow.png',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41],
    });
  }

  public updateRange(): void {
    if (this.rangeCircle) {
      // Update circle radius
      this.rangeCircle.setRadius(this.range);

      // Update popup content
      this.marker.setPopupContent(
        `Location<br>Lat: ${this.latitude.toFixed(
          5
        )}<br>Lng: ${this.longitude.toFixed(5)}<br>Range: ${this.range} km`
      );

      // Fit map to new range
      this.fitMapToRange();
    }
  }

  public updateLocation(lat?: number, lng?: number): void {
    if (lat) this.latitude = lat;
    if (lng) this.longitude = lng;
    this.syncCoordinateInputs();

    if (this.marker && this.rangeCircle && this.map) {
      // Update marker position
      this.marker.setLatLng([this.latitude, this.longitude]);

      // Update circle position
      this.rangeCircle.setLatLng([this.latitude, this.longitude]);

      // Update popup
      //this.marker.setPopupContent(`Location<br>Lat: ${lat.toFixed(5)}<br>Lng: ${lng.toFixed(5)}<br>Range: ${this.range} km`);

      // Center map on new location
      this.map.setView([this.latitude, this.longitude]);

      // Update address if not called from address search
      if (!this.isSearching) {
        this.reverseGeocode(this.latitude, this.longitude);
      }

      // Fit map to range
      this.fitMapToRange();
    }
  }

  public setrange(range: number): void {
    this.range = range;
    this.updateRange();
  }

  private fitMapToRange(): void {
    if (this.map && this.rangeCircle) {
      // Get circle bounds and fit map
      const bounds = this.rangeCircle.getBounds();
      this.map.fitBounds(bounds, {
        padding: [20, 20],
        maxZoom: 15, // Don't zoom in too much
      });
    }

    this.validateData();
  }


  downloadQR(index: number, code: string) {
    this.loadingQrCode = true;
    const host = this.qrComps.toArray()[index]?.nativeElement as
      | HTMLElement
      | undefined;
    if (!host) return;

    const srcCanvas = host.querySelector("canvas") as HTMLCanvasElement | null;
    if (!srcCanvas) return;

    const dpr = window.devicePixelRatio || 1;

    // Dimensioni del QR (in pixel del canvas di origine)
    const qrW = srcCanvas.width;
    const qrH = srcCanvas.height;

    // Stile colori (coerente con angularx-qrcode sopra)
    const bgColor = "#1e1e1e";
    const fgColor = "#F7F737";

    // Impostazioni testo
    const padding = 16; // padding sopra/sotto il testo (in CSS px)
    let fontSize = 18; // dimensione base (CSS px)
    const fontFamily = "Inter, Arial, sans-serif";
    const text = code || "";

    // Misurazione e adattamento del font alla larghezza del QR
    const measureCtx = document.createElement("canvas").getContext("2d")!;
    const fitText = (targetWidth: number) => {
      let fs = fontSize;
      while (fs > 10) {
        measureCtx.font = `${fs * dpr}px ${fontFamily}`;
        const w = measureCtx.measureText(text).width;
        if (w <= (targetWidth - 24) * dpr) break; // 24px margine orizzontale
        fs -= 1;
      }
      return fs;
    };
    fontSize = fitText(qrW / dpr);

    // Altezze calcolate in px canvas (moltiplicate per dpr)
    const textLineHeight = Math.round(fontSize * 1.4 * dpr);
    const padPx = Math.round(padding * dpr);

    // Canvas di output (stessa larghezza del QR; altezza = QR + padding + testo + padding)
    const outCanvas = document.createElement("canvas");
    outCanvas.width = qrW;
    outCanvas.height = qrH + padPx + textLineHeight + padPx;

    const ctx = outCanvas.getContext("2d")!;
    // Sfondo
    ctx.fillStyle = bgColor;
    ctx.fillRect(0, 0, outCanvas.width, outCanvas.height);

    // Disegno del QR (in alto)
    ctx.drawImage(srcCanvas, 0, 0);

    // Disegno del testo centrato
    //ctx.fillStyle = fgColor;
    ctx.fillStyle = "#ffffff";
    ctx.font = `${fontSize * dpr}px ${fontFamily}`;
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText(
      text,
      outCanvas.width / 2,
      qrH + padPx + Math.floor(textLineHeight / 2),
    );

    // Download PNG
    const dataURL = outCanvas.toDataURL("image/png");
    const a = document.createElement("a");
    a.href = dataURL;
    a.download = `qr_${this.sanitizeFilename(code)}.png`;
    a.click();

    this.loadingQrCode = false;
  }

  sanitizeFilename(name: string) {
    return (name || "code")
      .replace(/[<>:"/\\|?*\x00-\x1F]/g, "_")
      .slice(0, 100);
  }

  // Method to get current center and range (useful for parent component)
  public getCurrentState(): { lat: number; lng: number; range: number } {
    return {
      lat: this.latitude,
      lng: this.longitude,
      range: this.range,
    };
  }

  parseCoordinateInput(value: string | number | null | undefined): number | null {
    if (value === null || value === undefined || value === '') {
      return null;
    }

    if (typeof value === 'number') {
      return Number.isFinite(value) ? value : null;
    }

    const normalized = value.trim().replace(',', '.');
    const parsedValue = Number(normalized);

    return Number.isFinite(parsedValue) ? parsedValue : null;
  }

  onLatitudeInputChange(value: string | number | null | undefined): void {
    this.latitudineInput = value?.toString() ?? '';
    const parsed = this.parseCoordinateInput(value);
    if (parsed === null) {
      return;
    }

    this.latitude = parsed;
    this.updateLocation(parsed, undefined);
  }

  onLongitudeInputChange(value: string | number | null | undefined): void {
    this.longitudineInput = value?.toString() ?? '';
    const parsed = this.parseCoordinateInput(value);
    if (parsed === null) {
      return;
    }

    this.longitude = parsed;
    this.updateLocation(undefined, parsed);
  }

  private syncCoordinateInputs(): void {
    this.latitudineInput = this.latitude.toString();
    this.longitudineInput = this.longitude.toString();
  }
}
export { selectionButtonClass };
